export var FILTER_LAYOUT_CLASS_PREFIX = 'FilterLayout';